import type { ReactNode } from "react";
import { Feedback, type FeedbackStatus } from "../internal/Feedback";

export type ToastStatus = FeedbackStatus;

interface ToastActionProps {
  label: string;
  onPress: () => void;
}

function ToastAction({ label, onPress }: ToastActionProps) {
  return <Feedback.Action label={label} onPress={onPress} />;
}

export interface ToastProps {
  children?: ReactNode;
  description: string;
  onClose?: () => void;
  status: ToastStatus;
  title: string;
}

export function Toast({ children, description, onClose, status, title }: ToastProps) {
  return (
    <Feedback.Root status={status} title={title} description={description} onClose={onClose}>
      {children}
    </Feedback.Root>
  );
}

Toast.Action = ToastAction;
